import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OOTSRequirements } from 'src/app/_model/oots-requirements';

@Component({
  selector: 'app-structured-data',
  templateUrl: './structured-data.component.html',
  styleUrl: './structured-data.component.css'
})
export class StructuredDataComponent {

  @Input() structuredData: StructuredData;
  @Input() dataTitle: string;

  public requirements = OOTSRequirements;

  constructor(
    public translate: TranslateService
  ) {

  }
}

export interface StructuredData {
  requirement: OOTSRequirements;
  data: any;
}